import { getAppPath } from "./ImageHelper";

export const addFontFaces = () => {
	const newStyle = document.createElement("style");
	const appPath = getAppPath();
	newStyle.appendChild(
		document.createTextNode(`@font-face {
	  font-family: "Roboto";
	  src: url(${window.location.origin}${appPath ? `/${appPath}` : ""}/fonts/Roboto-Medium.ttf);
	}
		`)
	);
	newStyle.appendChild(
		document.createTextNode(`@font-face {
	  font-family: "IberPangeaVAR";
	  src: url(${window.location.origin}${appPath ? `/${appPath}` : ""}/fonts/IberPangeaVAR.woff2);
	}
		`)
	);
	document.head.appendChild(newStyle);
};
